export const checkPasswordStrengthFn = (pwd) => {
  const checks = {
    length: pwd.length >= 8,
    uppercase: /[A-Z]/.test(pwd),
    lowercase: /[a-z]/.test(pwd),
    number: /[0-9]/.test(pwd),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
  };
  const passedChecks = Object.values(checks).filter(Boolean).length;
  let score = 0, label = '', color = '';
  if (passedChecks <= 2) { score = 1; label = 'Weak'; color = 'text-red-600'; }
  else if (passedChecks === 3) { score = 2; label = 'Fair'; color = 'text-orange-600'; }
  else if (passedChecks === 4) { score = 3; label = 'Good'; color = 'text-yellow-600'; }
  else { score = 4; label = 'Strong'; color = 'text-green-600'; }
  return { score, label, color, checks };
};
